import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Stack, Typography } from '@mui/material';

// O aviso precisa pintar antes do trabalho pesado. O timeout só solta depois,
// para o clique que ficou na fila durante a travada não disparar de novo.
export function useMapaOcupado(ocupadoExterno, onOcupacao) {
  const [processando, setProcessando] = useState(false);
  const processandoRef = useRef(false);
  const externoRef = useRef(Boolean(ocupadoExterno));
  const onOcupacaoRef = useRef(onOcupacao);
  const geracaoRef = useRef(0);
  const timerRef = useRef(null);
  externoRef.current = Boolean(ocupadoExterno);
  onOcupacaoRef.current = onOcupacao;

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    geracaoRef.current += 1;
    if ((processandoRef.current || externoRef.current) && onOcupacaoRef.current) {
      onOcupacaoRef.current(false);
    }
  }, []);

  const ocupar = () => {
    if (processandoRef.current || externoRef.current) return false;
    geracaoRef.current += 1;
    processandoRef.current = true;
    setProcessando(true);
    if (onOcupacaoRef.current) onOcupacaoRef.current(true);
    return true;
  };

  const encerrar = () => {
    if (!processandoRef.current && !externoRef.current) return;
    const geracao = geracaoRef.current + 1;
    geracaoRef.current = geracao;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (geracao !== geracaoRef.current) return;
      processandoRef.current = false;
      setProcessando(false);
      if (onOcupacaoRef.current) onOcupacaoRef.current(false);
    }, 0);
  };

  return {
    aviso: processando || Boolean(ocupadoExterno),
    ocupar,
    encerrar,
    processandoRef,
    externoRef,
  };
}

const KmzMapaProcessando = ({ visivel }) => {
  if (!visivel) return null;
  return (
    <Stack
      role="status"
      aria-live="polite"
      aria-busy="true"
      alignItems="center"
      justifyContent="center"
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 7,
        bgcolor: 'rgba(15, 23, 42, 0.35)',
        cursor: 'wait',
      }}
    >
      <Stack
        direction="row"
        spacing={1.25}
        alignItems="center"
        sx={{
          bgcolor: 'background.paper',
          color: 'text.primary',
          borderRadius: 1,
          px: 2,
          py: 1.25,
          boxShadow: 3,
        }}
      >
        <CircularProgress size={22} />
        <Typography variant="body2">Atualizando o mapa</Typography>
      </Stack>
    </Stack>
  );
};

KmzMapaProcessando.propTypes = {
  visivel: PropTypes.bool,
};

KmzMapaProcessando.defaultProps = {
  visivel: false,
};

export default KmzMapaProcessando;
